export default {
  button:
    'uppercase font-condensed block text-12 sm:text-18 border px-15 h-52 hover:-translate-y-3 focus:-translate-y-3 transition-fast flex items-center justify-center',
  buttonWhite:
    'text-white border-white hover:text-jet-black focus:text-jet-black hover:bg-white focus:bg-white',
  buttonBlack: 'text-jet-black border-jet-black hover:bg-white focus:bg-white',
  buttonBlue:
    'text-danaher-blue border-danaher-blue hover:text-white focus:text-white hover:bg-danaher-blue focus:bg-danaher-blue',
  filter:
    'flex items-center mx-5 mb-15 border border-white rounded-full font-condensed uppercase text-18 px-15 py-15 hover:-translate-y-3 focus:-translate-y-3 transition-fast',
  filterDefault: 'text-jet-black bg-white',
  filterActive: 'text-white bg-jet-black'
}
